import { Minus, Plus } from "lucide-react";
import { Button } from "../ui/button";

// Eligible-products picker used by TransferDialog. Renders a scrollable
// list with +/- controls; pure presentational — caller owns the cart state.
export default function TransferProductList({ products, cart, onInc, onDec }) {
  return (
    <div className="max-h-64 overflow-y-auto bg-white border border-[#E6E0D4] rounded-xl divide-y divide-[#EEE8DC]">
      {products.slice(0, 80).map((p) => {
        const qty = cart[p.id] || 0;
        return (
          <div key={p.id} className="flex items-center gap-3 px-3 py-2">
            {p.image ? (
              <img
                src={p.image}
                alt=""
                className="h-10 w-10 rounded object-cover shrink-0"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
              />
            ) : (
              <div className="h-10 w-10 rounded bg-[#F3EFE7] shrink-0" />
            )}
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate">{p.name}</p>
              <p className="text-xs text-[#0B1F3A]/55">{p.category} · {p.unit}</p>
            </div>
            {qty === 0 ? (
              <Button size="sm" variant="outline" onClick={() => onInc(p.id)} className="border-[#E6E0D4]">
                <Plus size={14} />
              </Button>
            ) : (
              <div className="flex items-center gap-1 bg-[#F3EFE7] rounded-full p-1">
                <button onClick={() => onDec(p.id)} className="h-7 w-7 rounded-full bg-white border border-[#E6E0D4] flex items-center justify-center"><Minus size={14} /></button>
                <span className="min-w-7 text-center text-sm font-medium">{qty}</span>
                <button onClick={() => onInc(p.id)} className="h-7 w-7 rounded-full bg-[#0B1F3A] text-white flex items-center justify-center"><Plus size={14} /></button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
